import { render, staticRenderFns } from "./OrdersReportDetail.vue?vue&type=template&id=48744e58&scoped=true&"
import script from "./OrdersReportDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReportDetail.vue?vue&type=style&index=0&id=48744e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48744e58",
  null
  
)

export default component.exports